<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <lg-form-select @input="load" v-model="form.status" :loadFunction="statusList"
                        labelFormGroupBind="Status:" label="descricao" cols="12" sm="4" description=" "
                        filterList="true" :disabled="form.somenteAtrasados || status != null" />
                    <lg-form-input invalidFeedback=" " description="" v-model="form.numero" label="Número:" cols="12"
                        sm="5" />
                    <b-col cols="5">
                        <LgFinderPageEmpresa :label="'Fornecedor:'" v-model="form.empresa" :value="form.empresa"
                            id="finderEmpresaEmpenho" invalidFeedback="A empresa deve ser informada!" description=""
                            :prefix="updatedPrefix" @input="empresaSelect" />
                    </b-col>
                    <lg-form-date invalidFeedback=" " description="" v-model="form.dtEntregaInicial" label="De:"
                        cols="2" sm="2" />
                    <lg-form-date invalidFeedback=" " description="" v-model="form.dtEntregaFinal" label="Até:" cols="2"
                        sm="2" />


                </b-form-row>

                <b-row>

                    <b-col cols="4">
                        <b-form-checkbox v-model="form.somenteAtrasados" @change="load">
                            Somente não utilizados ({{ atrasadosCount }})
                        </b-form-checkbox>

                    </b-col>

                    <b-col cols="8" class="text-right">
                        <b-button id="localizarEmpenho" class="ml-1 mr-1 my-1" size="sm" style="height:40px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizarEmpenho" title="Localizar" triggers="hover"></b-tooltip>
                        </b-button>
                        <b-button id="limparEmpenho" class=" ml-1 mr-1 my-2" size="sm" style="height: 40px" pill
                            variant="primary" @click="limpar">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limparEmpenho" title="Limpar" triggers="hover"></b-tooltip>
                        </b-button>
                        <b-button v-if="temPrivilegioAdicionar()" id="novoEmpenho" class="ml-1 mr-2 my-2"
                            @click="abrirModalEdit" style="height: 40px" size="sm" pill variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                        </b-button>
                        <b-tooltip target="novoEmpenho" title="Adicionar novo..." triggers="hover"></b-tooltip>

                    </b-col>


                </b-row>
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" @row-dblclicked="empenhoSelect" show-empty>


                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(remove)="{ item }">

                        <b-button v-if="item.idStatus === 180 && temPrivilegioExcluir()" :id="'excluir-' + item.id"
                            class="my-2" size="sm" pill variant="danger" @click="excluirEmpenho(item)">
                            <b-icon icon="trash" />
                            <b-tooltip :target="'excluir-' + item.id" title="Excluir" triggers="hover"></b-tooltip>
                        </b-button>

                    </template>

                    <template v-slot:cell(edit)="{ item }">
                        <b-button v-if="item.idStatus === 180 && temPrivilegioEditar()" :id="'editar-' + item.id"
                            class="my-2" size="sm" pill variant="primary" @click="abrirModalEdit(item)">
                            <b-icon icon="pencil-square" />
                            <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
                        </b-button>

                    </template>

                    <template v-slot:cell(disable)="{ item }">
                        <b-button v-if="item.idStatus === 180 && temPrivilegioConcluir()" :id="'concluir-' + item.id"
                            class="my-2" size="sm" pill variant="success" @click="confirmarConcluirEmpenho(item)">
                            <b-icon icon="check-circle" />
                            <b-tooltip :target="'concluir-' + item.id" title="Concluir" triggers="hover"></b-tooltip>
                        </b-button>

                        <b-button v-else-if="item.idStatus === 181 && temPrivilegioReabrir()" :id="'reabrir-' + item.id"
                            class="my-2" size="sm" pill variant="warning" @click="confirmarReabrirEmpenho(item)">
                            <b-icon icon="door-open" />
                            <b-tooltip :target="'reabrir-' + item.id" title="Reabrir" triggers="hover"></b-tooltip>
                        </b-button>

                    </template>


                    <template v-slot:cell(action)="{ item }">

                        <b-button :id="'nota-fiscal-' + item.id" class="my-2" size="sm" pill variant="info"
                            @click="abrirRegistroEntrada(item)">
                            <b-icon icon="file-earmark-text" />
                            <b-tooltip :target="'nota-fiscal-' + item.id" title="Nota Fiscal"
                                triggers="hover"></b-tooltip>
                        </b-button>


                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <EmpenhoForm v-if="showModalEdit" @close="cancelar" :isModal="true" :id="id" :empresaNome="nomeEmpresa"
            :codEmpresa="codigoEmpresa" :prefix="updatedPrefix" />

        <ModalRegistroEntradaList v-if="showModalRegistroEntradaList" :prefix="prefix + title"
            @close="fecharRegistroEntradaForm" :empenho='empenhoSelecionado' />


    </b-card>
</template>

<script>
import moment from "moment";

import ResourceService from "@/core/api/ResourceService";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import EmpenhoForm from "./EmpenhoForm.vue";
import LgFinderPageEmpresa from "../../../components/Finders/LgFinderPageEmpresa.vue";
import API from "@/core/api";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModalRegistroEntradaList from "@/modules/almoxarifados/registros-entrada/ModalRegistroEntradaList.vue";


export default {
    components: {
        LgFormInput,
        LgFormSelect,
        LgFormDate,
        EmpenhoForm,
        LgFinderPageEmpresa,
        ModalRegistroEntradaList
    },
    name: "EmpenhoList",
    data() {
        return {
            showModalRegistroEntradaList: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            id: null,
            nomeEmpresa: "",
            codigoEmpresa: this.codEmpresa || null,
            showModalEdit: false,
            atrasadosCount: 0,
            form: {
                id: "",
                descricao: "",
                numero: "",
                dtEntregaInicial: "",
                dtEntregaFinal: "",
                status: { id: null, descricao: "Todos" },
                empresa: {},
                somenteAtrasados: false,
            },
        };
    },
    props: {
        status: {
            type: Object,
            default: null
        },
        contrato: {
            type: Object,
            default: null
        },
        codEmpresa: Number,
        prefix: {
            Array,
            default: () => [],
        },
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    async beforeMount() {
        this.$statusService = new ResourceService(`/api/status/tipo/54`);
        this.$service = new ResourceService(`/api/empenhos`);
        if (this.status != null)
            this.form.status = this.status;
        this.load();

    },
    watch: {
        page() {
            this.load();
        },
        'form.somenteAtrasados'(newValue) {
            if (newValue) {
                this.form.status = { id: 180, descricao: "Em Andamento" };
            }
            else
                this.form.status = { id: null, descricao: "Todos" }
        },
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Empenho"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
        tableFields() {
            return [
                {
                    key: "numero",
                    label: "Número",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger" : "";
                    },
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger" : "";
                    },
                },
                {
                    key: "empresa",
                    label: "Fornecedor",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger" : "";
                    },
                },
                {
                    key: "dtEntrega",
                    label: "Data entrega",
                    formatter: (value) =>
                        value ? moment(value).format('DD/MM/YYYY') : "-",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger" : "";
                    },
                },
                {
                    key: "vlTotal",
                    label: "Valor (R$)",
                    thClass: "",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger" : "";
                    },
                    formatter: (value) => {
                        if (!value)
                            return "";
                        return value.toLocaleString("pt-BR", {
                            style: "decimal",
                            currency: "BRL",
                            minimumFractionDigits: 2,
                        });
                    },
                },
                {
                    key: "vlDisponivel",
                    label: "Disponível (R$)",
                    thClass: "",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger " : "";
                    },
                    formatter: (value) => {
                        if (value == null || value == undefined)
                            return value;

                        return value.toLocaleString("pt-BR", {
                            style: "decimal",
                            currency: "BRL",
                            minimumFractionDigits: 2,
                        });
                    },
                },
                {
                    key: "status",
                    label: "Status",
                    thClass: "text-center",
                    tdClass: (value, index, item) => {
                        return item.atrasado ? "text-danger text-center" : "text-center";
                    },
                },
                { key: "action", label: " " },
                { key: "edit", label: " " },
                { key: "disable", label: " " },
                { key: "remove", label: " " },

            ];
        },
    },
    methods: {

        fecharRegistroEntradaForm() {
            this.showModalRegistroEntradaList = false;
            this.load();
        },

        temPrivilegioExcluir() {
            return verificaPrivilegio(PrivilegiosEnum.EMPENHO_EXCLUIR);
        },

        temPrivilegioConcluir() {
            return verificaPrivilegio(PrivilegiosEnum.EMPENHO_CONCLUIR);
        },

        temPrivilegioReabrir() {
            return verificaPrivilegio(PrivilegiosEnum.EMPENHO_REABRIR);
        },


        temPrivilegioEditar() {
            return verificaPrivilegio(PrivilegiosEnum.EMPENHO_EDITAR);
        },


        temPrivilegioAdicionar() {
            return verificaPrivilegio(PrivilegiosEnum.EMPENHO_INCLUIR);
        },
        empresaSelect(empresa) {
            this.form.empresa = empresa;
            this.load();
        },
        limpar() {
            this.form.id = "";
            this.form.numero = "";
            this.form.dtEntregaInicial = "";
            this.form.dtEntregaFinal = "";
            this.form.status = { id: null, descricao: "Todos" };
            this.form.empresa = {};
            this.load();
        },
        async load() {
            this.filtros = {};

            if (this.form.id != undefined && this.form.id != "") {
                this.filtros.id = this.form.id;
            }
            if (this.form.descricao != undefined && this.form.descricao != "") {
                this.filtros.descricao = this.form.descricao;
            }
            if (this.form.numero != undefined && this.form.numero != "") {
                this.filtros.numero = this.form.numero;
            }
            if (this.form.dtEntregaInicial) {
                this.filtros.dtEntregaInicial = new Date(this.form.dtEntregaInicial).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }
            if (this.form.dtEntregaFinal) {
                this.filtros.dtEntregaFinal = new Date(this.form.dtEntregaFinal).toLocaleDateString('pt-BR', {
                    timeZone: 'UTC'
                });
            }

            if (this.form.dtEntregaInicial && this.form.dtEntregaFinal) {
                const ini = new Date(this.form.dtEntregaInicial);
                const fim = new Date(this.form.dtEntregaFinal);

                if (ini > fim) {
                    this.busy = false;
                    this.$notify({
                        type: "danger",
                        message: "Informe as datas corretamente.",
                    });
                    return;
                }
            }

            if (this.form.empresa && this.form.empresa.id) {
                this.filtros.codigoEmpresa = this.form.empresa.id;
            }
            if (this.form.status && this.form.status.id) {
                this.filtros.codigoStatus = this.form.status.id;
            }

            if (this.contrato && this.contrato.id)
                this.filtros.contrato = this.contrato.id;

            if (this.form.somenteAtrasados) {
                this.filtros.somenteAtrasados = this.form.somenteAtrasados;
            }
            this.busy = true;
            API.get(`/api/empenhos/quantidadeAtrasados`).then((response) => {
                this.atrasadosCount = response.data;
            });

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtros,
                isOrOperation: "true",
            });
        },
        async statusList({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 });
        },
        async registrosEntradaAssociados({ id }) {
            this.$router.push({ name: `registrosEntradasAssoc`, params: { id } });
        },
        abrirModalEdit(item) {
            this.id = item.id;
            this.nomeEmpresa = item.razaoSocial;
            this.showModalEdit = true;
        },
        cancelar() {
            this.showModalEdit = false;
            this.id = null;
            this.nomeEmpresa = "";
            this.codigoEmpresa = null;
            this.load();
        },
        async confirmarConcluirEmpenho(item) {
            let response = await this.$confirm(
                "Deseja concluir este empenho?",
                item.descricao ? item.descricao.toUpperCase() : item.numero
            );
            if (response == true) {
                this.concluirEmpenho(item);
            }
        },
        async concluirEmpenho(item) {
            const { status } = await API.put(`/api/empenhos/${item.id}/concluir`);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Empenho concluído com sucesso!`,
                });
                this.load();
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao concluir o empenho!`,
                });
            }
        },
        async confirmarReabrirEmpenho(item) {
            let response = await this.$confirm(
                "Deseja reabrir este empenho?",
                item.descricao.toUpperCase()
            );
            if (response == true) {
                this.reabrirEmpenho(item);
            }
        },
        async reabrirEmpenho(item) {
            const { status } = await API.put(`/api/empenhos/${item.id}/reabrir`);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Empenho reaberto com sucesso!`,
                });
                this.load();
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao reabrir o empenho!`,
                });
            }
        },

        async excluirEmpenho(item) {
            this.$removeResource(item);
        },
        abrirRegistroEntrada(item) {
            this.empenhoSelecionado = item;
            this.showModalRegistroEntradaList = true;
        },
        Remover(item) {
            this.$removeResource(item);
        },
        empenhoSelect(item) {
            this.$emit("onDblClickEmpenhoSelect", item);
        },
    },
};
</script>

<style scoped>
.text-danger {
    color: red;
}
</style>
<style>
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__clear,
.vs--disabled .vs__search,
.vs--disabled .vs__selected,
.vs--disabled .vs__open-indicator {
    cursor: not-allowed;
}
</style>
